<div class="padded-content legal-content">
  <app-gtc></app-gtc>
</div>
